import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';

interface FormParams {
  contracts: any[];
  onSubmit: any;
}
function WarehouseContractLineForm(params: FormParams) {
  const { onSubmit, contracts } = params;
  const { t } = useTranslation();

  return (
    <div>
      <ReactFinalForm onSubmit={onSubmit} formId="addContractLine" hideControls>
        <div className="flex flex-col gap-4 my-4">
          {/* Prima riga: solo il campo contract_header */}
          <div className="mx-2">
            <IdentityField
              name="contract_header"
              component={AutocompleteAdapter}
              options={contracts}
              label={t('global.contract')}
            />
          </div>

          {/* Seconda riga: unit_price + initial_available_units */}
          <div className="flex gap-4">
            <div className="mx-2 flex-1">
              <IdentityField
                name="unit_price"
                component={TextFieldAdapter}
                type="number"
                label={t(`entities.contract_line.unit_price`)}
              />
            </div>
            <div className="mx-2 flex-1">
              <IdentityField
                name="initial_available_units"
                component={TextFieldAdapter}
                type="number"
                label={t(`entities.contract_line.initial_available_units`)}
              />
            </div>
          </div>

          {/* Terza riga: initial_discounted_units + iva */}
          <div className="flex gap-4">
            <div className="mx-2 flex-1">
              <IdentityField
                name="initial_discounted_units"
                component={TextFieldAdapter}
                type="number"
                label={t('entities.contract_line.initial_discounted_units')}
              />
            </div>
            <div className="mx-2 flex-1">
              <IdentityField
                name="iva"
                component={TextFieldAdapter}
                type="number"
                label={t('entities.contract_line.iva')}
              />
            </div>
          </div>
        </div>
      </ReactFinalForm>
    </div>
  );
}

export default WarehouseContractLineForm;
